import React, { useState } from "react";
import { useAuthContext } from "../../../../Context/AuthContext";
import TimezoneSelect from "react-timezone-select";
import flowChangerLogo from "../../../../Assets/Images/flowchangerAINew.jpeg";
import { useSearchParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useGlobalContext } from "../../../../Context/GlobalContext";
import loginSlash from "../../../../Assets/Images/login-slash.jpeg";
import loginLady from "../../../../Assets/Images/login-lady.png";

const Step5 = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { openToast } = useGlobalContext();

  const { nextStep, updateExtraInfo, extraInfo } = useAuthContext();
  const [timeZone, setTimeZone] = useState({
    value: "Asia/Kolkata",
    label: "India (GMT+5:30)",
  });

  const handleTimeZoneChange = (selected) => {
    if (
      selected.value.includes("Asia/Kolkata") ||
      selected.label.includes("India")
    ) {
      setTimeZone({ value: "Asia/Kolkata", label: "India (GMT+5:30)" });
    } else {
      setTimeZone(selected);
    }
  };

  const [timeFormate, setTimeFormate] = useState("12-hour");
  const [dateFormate, setDateFormate] = useState("MM/DD/YYYY");
  const [weekFormate, setWeekFormate] = useState("Sunday");
  const email = searchParams.get("email");
  console.log(email);

  const handleNextStep = () => {
    if (timeFormate && timeZone?.value && dateFormate && weekFormate) {
      updateExtraInfo({
        time_zone: timeZone && timeZone.value,
        time_formate: timeFormate,
        date_formate: dateFormate,
        week_formate: weekFormate,
      });
      nextStep();
      setSearchParams({ step: 6, email: email });
    } else {
      openToast("all fields are required", "error");
    }
  };

  return (
    <div className="flex justify-center items-center px-[10px] md:px-[20px] lg:px-[20px] xl:px-[20px] py-[10px] md:py-[20px] lg:py-[20px] xl:py-[20px] h-screen overflow-y-scroll">
      <div className="flex justify-center bg-white rounded-lg w-[100%] lg:w-[100%] xl:w-[80%] h-[100%] login-div">
        <div className="md:p-[10px] px-6 md:px-2 lg:px-[62px] xl:px-[30px] py-[20px] w-full md:w-1/2 h-[100%] overflow-y-scroll">
          <div className="flex justify-center items-center mt-2">
            <img src={flowChangerLogo} className="w-[120px]" />
          </div>
          <h1 className="mb-6 font-semibold text-2xl text-center">
            Set up your account
          </h1>

          <div className="space-y-6">
            {/* Time zone */}
            {/* Time zone */}
            <div>
              <label className="block mb-2 font-medium text-gray-700 text-sm">
                Time zone
              </label>
              <TimezoneSelect
  value={timeZone}
  onChange={handleTimeZoneChange}
  className="bg-white shadow-cs px-3 py-3 rounded-md focus:outline-none w-full"
  filterOptions={(options) => {
    return options.filter((option) => option.value === "Asia/Kolkata");
  }}
/>
            </div>

            {/* Time format */}
            <div>
              <label className="block mb-2 font-medium text-gray-700 text-sm">
                Time format
              </label>
              <div className="flex gap-4">
                <button
                  className={`flex-1 py-2 px-4 rounded-full ${
                    timeFormate === "12-hour"
                      ? "bg-[#8a25b0] text-white"
                      : "bg-gray-100"
                  }`}
                  onClick={() => setTimeFormate("12-hour")}
                >
                  12 hours: 9:00 PM
                </button>
                <button
                  className={`flex-1 py-2 px-4 rounded-full ${
                    timeFormate === "24-hour"
                      ? "bg-[#8a25b0] text-white"
                      : "bg-gray-100"
                  }`}
                  onClick={() => setTimeFormate("24-hour")}
                >
                  24 hours: 21:00
                </button>
              </div>
            </div>

            {/* Date format */}
            <div>
              <label className="block mb-2 font-medium text-gray-700 text-sm">
                Date format
              </label>
              <div className="flex gap-4">
                <button
                  className={`flex-1 py-2 px-4 rounded-full ${
                    dateFormate === "31 December 2022"
                      ? "bg-[#8a25b0] text-white"
                      : "bg-gray-100"
                  }`}
                  onClick={() => setDateFormate("31 December 2022")}
                >
                  31 December 2022
                </button>
                <button
                  className={`flex-1 py-2 px-4 rounded-full ${
                    dateFormate === "December 31,2022"
                      ? "bg-[#8a25b0] text-white"
                      : "bg-gray-100"
                  }`}
                  onClick={() => setDateFormate("December 31,2022")}
                >
                  December 31, 2022
                </button>
              </div>
            </div>

            {/* Week format */}
            <div>
              <label className="block mb-2 font-medium text-gray-700 text-sm">
                Week format
              </label>
              <div className="flex gap-4 mb-4">
                <button
                  className={`flex-1 py-2 px-4 rounded-full ${
                    weekFormate === "Monday"
                      ? "bg-[#8a25b0] text-white"
                      : "bg-gray-100"
                  }`}
                  onClick={() => setWeekFormate("Monday")}
                >
                  Monday
                </button>
                <button
                  className={`flex-1 py-2 px-4 rounded-full ${
                    weekFormate === "Sunday"
                      ? "bg-[#8a25b0] text-white"
                      : "bg-gray-100"
                  }`}
                  onClick={() => setWeekFormate("Sunday")}
                >
                  Sunday
                </button>
              </div>
            </div>

            {/* Continue button */}
            <button
              onClick={handleNextStep}
              className="bg-[#8a25b0] hover:bg-[#884a9f] px-4 py-2 rounded-full w-full text-white transition duration-300"
            >
              Continue
            </button>
          </div>
        </div>

        <div className="hidden login-right relative md:flex justify-center items-center bg-[#9181F4] px-[30px] py-[10px] w-[50%] md:w-1/2 lg:w-[50%] xl:w-[50%] text-4xl text-center">
          <div className="relative bg-[#e2e0e938] border border-[#bfbfbf66] rounded-xl w-[80%] h-[83%]">
            <h2 className="p-[18px] w-[212px] font-bold text-[32px] text-white md:text-[22px] text-left">
              Personalize your account for a seamless experience
            </h2>
            <div className="top-[80px] right-[-53px] bottom-0 absolute">
              <img src={loginLady} alt="loginLady" />
            </div>
            <div className="bottom-[84px] left-[-20px] absolute bg-white p-[10px] rounded-full">
              <img src={loginSlash} alt="loginSlash" className="rounded-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step5;
